var _rect, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStoresLogo4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "#F1F4F3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.8062 78L45.8385 75.8498L41.8708 78L37.9031 75.8498L33.9354 78L29.9677 75.8498L26 78C26 78 29.2083 62.6838 29.2083 50.0043C29.2083 37.3162 26 22.0085 26 22.0085L29.9677 24.1588L33.9354 22.0085L37.9031 24.1588L41.8708 22.0085L45.8385 24.1588L49.8062 22.0085L53.7739 24.1588L57.7416 22.0085L61.7093 24.1588L65.677 22.0085L69.6447 24.1588L73.6124 22.0085C73.6124 22.0085 70.4041 37.3247 70.4041 50.0043C70.4041 62.6924 73.6124 78 73.6124 78L69.6447 75.8498L65.677 78L61.7093 75.8498L57.7416 78L53.7739 75.8498L49.8062 78Z",
    fill: "#FAE7DB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M65.677 22L61.7093 24.1502L57.7416 22L53.7739 24.1502L49.8062 22L45.8385 24.1502L41.8708 22L37.9031 24.1502L33.9354 22L29.9677 24.1502L26 22C26 22 26.5119 24.4403 27.1263 28.1777H72.4946C73.1089 24.4403 73.6209 22 73.6209 22L69.6532 24.1502L65.677 22Z",
    fill: "#2B5B4F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9439 78L37.9116 75.8498L41.8793 78L45.847 75.8498L49.8147 78L53.7824 75.8498L57.7501 78L61.7178 75.8498L65.6855 78L69.6532 75.8498L73.6209 78C73.6209 78 73.1089 75.5597 72.4946 71.8224H27.1263C26.5119 75.5597 26 78 26 78L29.9677 75.8498L33.9439 78Z",
    fill: "#2B5B4F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M49.8126 65.7983C55.2319 65.7983 59.6252 58.7233 59.6252 49.9958C59.6252 41.2683 55.2319 34.1933 49.8126 34.1933C44.3932 34.1933 40 41.2683 40 49.9958C40 58.7233 44.3932 65.7983 49.8126 65.7983Z",
    fill: "#D7513E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStoresLogo4);
export default __webpack_public_path__ + "static/media/stores-logo-4.9aa5ba63396ddb8110741ca6694848a7.svg";
export { ForwardRef as ReactComponent };